import { Button, Center, Stack, Text, ThemeIcon } from '@mantine/core';
import type { ReactNode } from 'react';

/** Friendly empty state: icon + title + optional hint + optional CTA. */
export function EmptyState({
  icon,
  title,
  hint,
  action,
}: {
  icon?: ReactNode;
  title: string;
  hint?: string;
  action?: { label: string; onClick: () => void };
}) {
  return (
    <Center py={48} px="md">
      <Stack align="center" gap="xs" maw={420}>
        {icon && (
          <ThemeIcon variant="light" color="gray" size={52} radius="xl">
            {icon}
          </ThemeIcon>
        )}
        <Text fw={600}>{title}</Text>
        {hint && <Text c="dimmed" size="sm" ta="center">{hint}</Text>}
        {action && (
          <Button variant="light" size="sm" mt="xs" onClick={action.onClick}>
            {action.label}
          </Button>
        )}
      </Stack>
    </Center>
  );
}
